type ArrowIconProps = {
  color?: string;
};
export const ArrowIcon = ({ color = "#ded287" }: ArrowIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.28752 12.834L11.2103 18.1549L9.74218 19.5131L2.6377 11.834L9.74218 4.15488L11.2103 5.5131L6.28752 10.834H21V12.834H6.28752Z"
        fill={color}
      />
    </svg>
  );
};
